import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import { useAutoAnimate } from '@formkit/auto-animate/react';
const TreeRoot = ({ maxHeight, disableAnimation, children }) => {
    const treeRootClasses = classNames('TreeRoot', 'user-select-none', maxHeight ? 'overflow-auto' : 'overflow-hidden');
    const [parent, enableAnimations] = useAutoAnimate();
    enableAnimations(!disableAnimation);
    return (_jsx("div", Object.assign({ ref: parent, className: treeRootClasses, style: { maxHeight } }, { children: children })));
};
export default TreeRoot;
